import AbstractIceContentController from '../../../abstract/ice-content/controller';
import WidgetFormTrackerModule from './app-form-tracker';
class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        this.init(widget);
    }
    init(widget) {
        if (!App.Portal.isInDesignMode()) {
            const widgetContext = $(widget.htmlNode);
            let helpers = new WidgetFormTrackerModule();
            let stepLabels = decodeURI(widget.getPreference("stepLabels"));
            let formStepper = $("#formStepper", widgetContext);
            if (!helpers.preferenceIsEmpty(stepLabels)) {
                let splitted = helpers.splitLabels(stepLabels);
                formStepper.empty();
                for (let count = 0; count < splitted.length; count++) {
                    formStepper.append(`<li class="form-section-header__section-item stepwizard-step">
                <a href="#step-${count + 1}" class="form-section-header__indicator" data-counter="${count + 1}"></a>
                <span class="form-section-header__title">${splitted[count]}</span>
                </li>`);
                }
            }
        }
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-form-tracker/widget/scripts/controller.js